import React, { useContext, useState } from "react";

//styling
import "./clusterRow.css";
import "./tableCellAuthentication.css";

//global state
import { StateContext } from "../../AppStateContext";

//Material UI stuff
import TableCell from "@material-ui/core/TableCell";
import ApiKeyModal from "./ClusterApiKeyModal";

import Link from "@material-ui/core/Link";

const ClusterRowInfoAuthentication = ({ clusterInfo }) => {
  //consume global state
  const state = useContext(StateContext);
  const [showApiKeyModal, setShowApiKeyModal] = useState(false);

  const sandboxId = clusterInfo.data.id;
  const authRequired = clusterInfo.data.configuration.requiresAuthentication;
  const apiKey = clusterInfo.data.configuration.apiKey;

  const openApiKeyModal = () => {
    setShowApiKeyModal(true);
  };

  const hideApiKeyModal = () => {
    setShowApiKeyModal(false);
  };

  return (
    <TableCell
      align="left"
      style={{
        borderBottom:
          state.theme === "dark" ? "1px solid #122742" : "1px solid #eaeaea",
      }}
    >
      <p
        className={
          state.theme === "dark"
            ? "__tableCell __tableCellAuthenticationTextWrapper __tableCellDark"
            : "__tableCell __tableCellAuthenticationTextWrapper __tableCellLight"
        }
      >
        <span>{authRequired ? "Enabled" : "public"}</span>
        {(authRequired && !!apiKey) ? (
          <Link
            className="__apiKeyButton"
            href="#"
            onClick={openApiKeyModal}
          >
            Show API Key
          </Link>
        ) : null}
      </p>
      {(authRequired && !!apiKey) ? <ApiKeyModal
        sandboxId={sandboxId}
        apiKey={apiKey}
        open={showApiKeyModal}
        closeFn={hideApiKeyModal}
      /> : null}
    </TableCell>
  );
};

export default ClusterRowInfoAuthentication;
